import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import OFFER from 'constants/offer';

const TAGS_BY_VISIBILITY = {
  [OFFER.VISIBILITY_STATUS.APP_ONLY]: OFFER.BADGES.APP_ONLY,
  [OFFER.VISIBILITY_STATUS.LOGGED_ONLY]: OFFER.BADGES.EXCLUSIVE,
};

const BASE_CLASSES =
  'whitespace-pre rounded-full px-2 py-0.5 text-xs font-regular bg-[#DCE7F4] text-primary-400 dark:bg-primary-100 dark:text-primary-400';

const OfferTag = ({ className, offerUserVisibility, offerTags = [] }) => {
  const visibilityLabel = TAGS_BY_VISIBILITY[offerUserVisibility];

  if (visibilityLabel) {
    return (
      <span className={twJoin(BASE_CLASSES, className)}>{visibilityLabel}</span>
    );
  }

  if (offerTags.length === 0) return null;

  return (
    <div
      className={twJoin(
        'flex min-w-0 flex-nowrap gap-1 overflow-x-auto scrollbar-none',
        className
      )}
    >
      {offerTags.map(({ name }) => (
        <span key={name} className={twJoin(BASE_CLASSES, 'shrink-0')}>
          {name}
        </span>
      ))}
    </div>
  );
};

OfferTag.propTypes = {
  className: PropTypes.string,
  offerUserVisibility: PropTypes.string,
  offerTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
};

export default OfferTag;
